<template>
  <div class="main">
    <van-nav-bar title="用户信息认证" />
    <div class="speepBox">
      <div class="list">
        <div class="num">1</div>
        <p>上传身份证</p>
        <div class="line"></div>
      </div>
      <div class="list active">
        <div class="num">2</div>
        <p>人脸识别</p>
        <div class="line"></div>
      </div>
      <div class="list">
        <div class="num">3</div>
        <p>验证结果</p>
      </div>
    </div>
    <div class="title">实名核实验证流程</div>
    <img src="~assets/image/sp.jpg" alt="" style="width: 60%; display: block; margin: 0 auto;">
    <div class="lc">
      <div class="list">
        <span>1</span>
        <p>点击按钮</p>
        <p>开始拍照</p>
      </div>
      <div class="list">
        <span>2</span>
        <p>保持正脸</p>
        <p>屏幕居中</p>
      </div>
      <div class="list">
        <span>3</span>
        <p>手动拍照</p>
        <p>点击上传验证</p>
      </div>
    </div>
    <input type="file" style="display: none;" accept="image/jpeg,image/png,image/webp" capture="camera" ref="fileOne" @change="getFile($event)">
    <div class="btnSubmit">
      <van-button round block type="info" @click="$refs.fileOne.click()">开始识别</van-button>
    </div>
    <van-overlay :show="showOverlay">
      <div class="wrapper" @click.stop>
        <van-loading color="#0094ff">识别中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { prepareSafeImage } from '@/utils/imageUpload';

export default {
  data() {
    return {
      showOverlay: false
    }
  },
  mounted() {

  },
  methods: {
    async getFile(e) {
      const input = e.target;
      const file = input.files[0];
      if (!file) return;

      this.showOverlay = true;
      try {
        const user = JSON.parse(window.localStorage.getItem('user'));
        if (!user || !user.name || !user.id) throw new Error('身份信息已失效，请重新上传身份证');

        const safeImage = await prepareSafeImage(file);
        const res = await this.api.face_id_card({
          image: safeImage,
          filename: file.name,
          name: user.name,
          idcard: user.id
        });
        if (Number(res.code) !== 200) throw new Error(res.msg || '人脸识别失败');

        this.$toast.success(res.msg || '验证成功');
        setTimeout(() => {
          this.$router.push('/rulestep/setp3');
        }, 1000);
      } catch (error) {
        this.$toast.fail(error.message || '图片校验失败，请重新上传');
      } finally {
        this.showOverlay = false;
        input.value = '';
      }
    },
    compressImgBySize(baseImg, maxSize = 800) {
      return new Promise((resolve) => {
        // 计算图片大小
        const strLength = baseImg.length
        const fileLength = parseInt(strLength - (strLength / 8) * 2)
        let size = parseInt((fileLength / 1024).toFixed(2))

        // 判断图片是否符合指定大小要求
        if (size <= maxSize) {
          resolve(baseImg)
          return
        }

        // 创建image对象
        const img = new Image()
        if (baseImg.indexOf('data:image/') !== -1) {
          img.src = baseImg
        } else {
          img.src = 'data:image/jpeg;base64,' + baseImg
        }

        img.onload = () => {
          // 把image对象 转换为 canvas对象
          const canvas = this.imgToCanvas(img)
          let resUrl = ''
          // 图片质量，范围：0 ~ 1
          let quality = 0.5

          // 当图片大小大于指定maxSize，图片质量大于0时继续通过降低图片资料来压缩
          while (size > maxSize && quality > 0) {
            console.log(maxSize, quality);
            // 在canvas上绘制该HTMLImageElement，得到图片base64
            resUrl = canvas.toDataURL('image/jpeg', quality).replace(/^data:image\/\w+;base64,/, '')
            const resLength = resUrl.length
            // 计算绘制出的base64图片大小
            const resFileLength = parseInt(resLength - (resLength / 8) * 2)
            size = parseInt((resFileLength / 1024).toFixed(2))
            // 降低图片质量
            quality = (quality - 0.1).toFixed(1)
          }
          resolve(resUrl)
        }
        img.onerror = () => {
          resolve(baseImg)
        }
      })
    },
    imgToCanvas(image) {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      canvas.getContext('2d').drawImage(image, 0, 0)
      return canvas
    },

    getImgSize(str) {
      // 带上前缀时需去掉前缀
      str = str.replace('data:image/png;base64,', '');
      if (typeof (str) == 'string') {
        var strLength = str.length;
        var fileLength = parseInt(strLength - (strLength / 8) * 2);

        // 由字节转换为KB
        var size = "";
        size = (fileLength / 1024).toFixed(2);
        // 由字节转换为MB
        size = (fileLength / 1024 * 1024).toFixed(2);

        return parseInt(size);
      }
      return parseInt(0);
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.main {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
}

.title {
  text-align: center;
  font-size: 18px;
}

.lc {
  display: flex;
  font-size: 14px;
  margin-bottom: 20px;
  padding-right: 20px;

  .list {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;

    span {
      text-align: center;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      line-height: 20px;
      text-align: center;
      background: #686868;
      color: #fff;
      margin-bottom: 6px;
    }

    p {
      margin: 0px 0px;
      color: #686868;
    }
  }
}</style>
